import { render, staticRenderFns } from "./WapFrontPage.vue?vue&type=template&id=8b200fa8&scoped=true&"
import script from "./WapFrontPage.vue?vue&type=script&lang=js&"
export * from "./WapFrontPage.vue?vue&type=script&lang=js&"
import style0 from "./WapFrontPage.vue?vue&type=style&index=0&id=8b200fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b200fa8",
  null
  
)

export default component.exports